import type { Row } from '../ability/context';
import type { ActivityPlan } from '../actions/activity';

/** Compose the due boundary with an interaction, retiring each exact row only once. */
export function withTrapClockMaintenance(fire: Row, clock: ActivityPlan): Row {
    if (!clock.writes.length) return fire;
    const removals = clock.writes.map(op => ({ status_id: String(op.id), holder_type: 'inventory', before: op.before }));
    if (fire.mode === 'no_fire') return { ...fire, maintenance: { rows: clock.rows, removals } };
    if (fire.mode !== 'rolled-v2') return fire;
    const verdict = fire.verdict as Row, lifecycle = verdict.lifecycle as Row;
    const existing = lifecycle.removals as typeof removals;
    const ids = new Set(existing.map(row => row.status_id.toUpperCase()));
    return { ...fire, verdict: { ...verdict, rows: [...clock.rows, ...verdict.rows as Row[]],
        lifecycle: { ...lifecycle, removals: [...existing, ...removals.filter(row => !ids.has(row.status_id.toUpperCase()))] } } };
}
